import { useEffect } from 'react';
import { useAuthStore } from '@/stores/useAuthStore';
import { myTracker } from '@/shared/utils/myTracker';

export const useMyTrackerAuthSync = (): void => {
  const userId = useAuthStore(state => state.user?.id);

  useEffect(() => {
    if (!userId) return;
    myTracker.setUserId(userId);
  }, [userId]);
};
